import React from 'react'
import PropTypes from 'prop-types'
import {Drawer} from '@chakra-ui/react3'
import {Chakra3MobileOnlyProvider} from '../../theme'
import Loading from '../loading-container'
import CmsModules from '../../modules'
import {useContentAsset} from '../../../hooks/useScapiCustomApi'

/**
 * Body content for the content drawer. Lazy-loaded on first open.
 * Loads CMS modules by asset ID and renders them inside a mobile-only Chakra context.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {string} props.contentId - Content asset ID to load and render.
 * @param {Array} [props.modules] - Preloaded modules; skips data fetching when provided.
 * @returns {JSX.Element}
 */
const ContentDrawerBody = ({contentId, modules: preloadedModules}) => {
    const {data: loadedModules, isInitialLoading} = useContentAsset(
        {parameters: {assetId: contentId}},
        {enabled: !preloadedModules && !!contentId}
    )

    const modules = preloadedModules || loadedModules
    const isLoading = !preloadedModules && isInitialLoading

    return (
        <Drawer.Body>
            <Chakra3MobileOnlyProvider>
                <Loading.Root>
                    <Loading.Status>
                        <Loading.Spinner isLoading={isLoading} />
                    </Loading.Status>
                    <Loading.Content>
                        <CmsModules assetId={contentId} modules={modules} />
                    </Loading.Content>
                </Loading.Root>
            </Chakra3MobileOnlyProvider>
        </Drawer.Body>
    )
}

ContentDrawerBody.propTypes = {
    contentId: PropTypes.string,
    modules: PropTypes.array
}

export default ContentDrawerBody
